// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","rotate":"Loader_rotate__SVGDU","ball1":"Loader_ball1__sh7Hk","ball2":"Loader_ball2__mGi62"};